import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 17.5198L16.15 20.0298C16.91 20.4898 17.84 19.8098 17.64 18.9498L16.54 14.2298L20.21 11.0498C20.88 10.4698 20.52 9.36977 19.64 9.29977L14.81 8.88977L12.92 4.42977C12.58 3.61977 11.42 3.61977 11.08 4.42977L9.19 8.87977L4.36 9.28977C3.48 9.35977 3.12 10.4598 3.79 11.0398L7.46 14.2198L6.36 18.9398C6.16 19.7998 7.09 20.4798 7.85 20.0198L12 17.5198Z",
		fill: "currentColor"
	})
});
export default SvgStar;
